import { Breadcrumbs, Typography } from "@mui/material";

type Props = {
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
};

export function TimestampBreadcrumbs({
  createdAt,
  updatedAt,
  deletedAt,
}: Props) {
  return (
    <Breadcrumbs separator="·">
      <Typography>{`Created at: ${createdAt ? new Date(createdAt).toLocaleString() : "Missing date!"}`}</Typography>
      <Typography>{`Updated at: ${updatedAt ? new Date(updatedAt).toLocaleString() : "Missing date!"}`}</Typography>
      {deletedAt && (
        <Typography>{`Deleted at: ${new Date(deletedAt).toLocaleString()}`}</Typography>
      )}
    </Breadcrumbs>
  );
}
